import { render } from "./SignageListSelectionModal.vue?vue&type=template&id=0b84ede8&scoped=true&ts=true"
import script from "./SignageListSelectionModal.vue?vue&type=script&lang=ts"
export * from "./SignageListSelectionModal.vue?vue&type=script&lang=ts"

import "./SignageListSelectionModal.vue?vue&type=style&index=0&id=0b84ede8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b84ede8"]])

export default __exports__